// extracted by mini-css-extract-plugin
module.exports = {"topBar":"_6d6315e","inner":"_69c123b","widgets":"_ad6dca9","metrics":"_227130a","divider":"_3fa5ab9"};